/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ServiceObjectStatusCreateV1Dto = {
  /**
   * ID of the contract associated with the maintenance status
   */
  contractId: string;
  /**
   * Interval for maintenance in combination with intervalUnit (e.g., 6 months)
   */
  interval: number;
  /**
   * Unit of the maintenance interval (e.g., Day, Week, Month, Year)
   */
  intervalUnit: ServiceObjectStatusCreateV1Dto.intervalUnit;
  /**
   * The next maintenance date. Must be after lastPerformedDate if it is provided.
   */
  nextDueDate?: string;
  /**
   * Notice period for the maintenance
   */
  notice: number;
  /**
   * Type of this status (e.g. Maintenance, Inspection)
   */
  type: ServiceObjectStatusCreateV1Dto.type;
  /**
   * Name of this status
   */
  name?: string;
};
export namespace ServiceObjectStatusCreateV1Dto {
  /**
   * Unit of the maintenance interval (e.g., Day, Week, Month, Year)
   */
  export enum intervalUnit {
    DAY = 'Day',
    WEEK = 'Week',
    MONTH = 'Month',
    YEAR = 'Year',
  }
  /**
   * Type of this status (e.g. Maintenance, Inspection)
   */
  export enum type {
    MAINTENANCE = 'Maintenance',
    INSPECTION = 'Inspection',
  }
}
